import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Authentication Store
 */
export const useAuthStore = create(
    persist(
        (set, get) => ({
            // State
            token: null,
            user: null,
            isAuthenticated: false,

            // Actions
            login: (token, user) => {
                set({
                    token,
                    user,
                    isAuthenticated: true,
                })
            },

            logout: () => {
                set({
                    token: null,
                    user: null,
                    isAuthenticated: false,
                })
            },

            updateUser: (userData) => {
                set((state) => ({
                    user: { ...state.user, ...userData },
                }))
            },

            updateToken: (token) => {
                set({ token })
            },

            // Getters
            getFormId: () => get().user?.form_id,
            getUserType: () => get().user?.user_type,
            getDepartmentId: () => get().user?.department_id,
            isAdmin: () => get().user?.user_type === 'admin',
            isDashboardUser: () => ['admin', 'dashboard'].includes(get().user?.user_type),
            isDepartmentUser: () => get().user?.user_type === 'department',
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({
                token: state.token,
                user: state.user,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
)

export default useAuthStore
